import { render, staticRenderFns } from "./producto.vue?vue&type=template&id=6bca2f3c&scoped=true&"
import script from "./producto.vue?vue&type=script&lang=js&"
export * from "./producto.vue?vue&type=script&lang=js&"
import style0 from "./producto.vue?vue&type=style&index=0&id=6bca2f3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bca2f3c",
  null
  
)

export default component.exports